// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input[data-v-8a0fec06]  .v-input__append-inner{cursor:pointer}.v-input[data-v-8a0fec06]  .v-input__append-inner .v-card{position:absolute;display:none;box-shadow:none;top:2.8rem;right:0;padding:.1rem;min-width:10rem;background:grey;z-index:10;opacity:.9}.v-input[data-v-8a0fec06]  .v-input__append-inner .v-card .v-card__text{padding:.5rem;color:#fff}.v-input[data-v-8a0fec06]  .v-input__append-inner:hover .v-card{display:block}", ""]);
// Exports
module.exports = exports;
